import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import { connect } from 'react-redux';

import { toggleTextEditMode } from 'Actions/UIActions';
import WveLinkButton from 'SharedComponents/WveInputs/WveLinkButton/WveLinkButton';

class WveInputEditButton extends Component {
  handleClick = (e) => {
    this.props.toggleTextEditMode();
    e.preventDefault();
  }
  render() {
    const { props: { textEditMode }, handleClick } = this;
    return (
      <WveLinkButton
        handleMouseDown={handleClick}
      >
        {textEditMode ? 'Done editing' : 'Edit text'}
      </WveLinkButton>
    );
  }
}

WveInputEditButton.propTypes = {
  toggleTextEditMode: PropTypes.func,
  textEditMode: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return {
    textEditMode: state.getIn(['monotype', 'textEditMode']),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    toggleTextEditMode: () => {
      dispatch(toggleTextEditMode());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WveInputEditButton);



// WEBPACK FOOTER //
// ./app/javascript/packs/Shared/components/WveInputs/WveInputEditButton/WveInputEditButton.jsx